export default function downloadFile(fileName: string, file: Blob) {
    // Handle download of the file
    const nav = (window.navigator as any);
    if (nav.msSaveBlob) {
        nav.msSaveBlob(file, fileName);
    } else {
        const anchor = window.document.createElement('a');
        anchor.href = window.URL.createObjectURL(file);
        anchor.download = fileName;
        anchor.target = '_blank';

        // Append anchor to body.
        document.body.appendChild(anchor);
        anchor.click();

        // Remove anchor from body
        document.body.removeChild(anchor);
        window.URL.revokeObjectURL(anchor.href);
    }
}